export default "__VITE_ASSET__DOCsiPSA__"